
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref920"];
var parcelRegister = parcelRequire.register;
parcelRegister("9RhoK", function(module, exports) {
$parcel$export(module.exports, "createPayloads", function () { return $72d68f2fee0a7403$export$51b606e6d67c2231; });
$parcel$export(module.exports, "createExperimentalMetricsPayload", function () { return $72d68f2fee0a7403$export$6410c9ddb2ab201; });

var $lrM5r = parcelRequire("lrM5r");

var $kOzMB = parcelRequire("kOzMB");

var $6HNZJ = parcelRequire("6HNZJ");

var $gNkVH = parcelRequire("gNkVH");

var $8oqW7 = parcelRequire("8oqW7");

var $39c3M = parcelRequire("39c3M");

var $ceERr = parcelRequire("ceERr");

var $cH3JV = parcelRequire("cH3JV");

var $jS0DY = parcelRequire("jS0DY");

var $as5v9 = parcelRequire("as5v9");

var $geLu7 = parcelRequire("geLu7");

var $03EZb = parcelRequire("03EZb");

var $f3CCR = parcelRequire("f3CCR");

var $bUAr3 = parcelRequire("bUAr3");

var $bLOdU = parcelRequire("bLOdU");

var $4gtBF = parcelRequire("4gtBF");

var $8pUKJ = parcelRequire("8pUKJ");

var $a48Mt = parcelRequire("a48Mt");

var $d39M6 = parcelRequire("d39M6");

var $87kDd = parcelRequire("87kDd");

var $1CoTB = parcelRequire("1CoTB");

var $4PhwH = parcelRequire("4PhwH");

var $hij2V = parcelRequire("hij2V");
var $72d68f2fee0a7403$var$_excluded = [
    "labelStack",
    "time"
], $72d68f2fee0a7403$var$_excluded2 = [
    "stopTime",
    "labelStack"
], $72d68f2fee0a7403$var$_excluded3 = [
    "labelStack"
], $72d68f2fee0a7403$var$_excluded4 = [
    "labelStack"
];
function $72d68f2fee0a7403$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $72d68f2fee0a7403$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $72d68f2fee0a7403$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $72d68f2fee0a7403$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $72d68f2fee0a7403$var$getUfoNameOverride(interaction) {
    var ufoName = interaction.ufoName, apdex = interaction.apdex;
    try {
        var ufoNameOverrides = (0, $03EZb.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            var metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    } catch (e) {
        return ufoName;
    }
}
function $72d68f2fee0a7403$var$getEarliestLegacyStopTime(interaction, labelStack) {
    var earliestLegacyStopTime = null;
    interaction.apdex.forEach(function(a) {
        var _a$labelStack, _earliestLegacyStopTi;
        if (!(a !== null && a !== void 0 && a.stopTime)) return;
        if (!(0, $hij2V.labelStackStartWith)((_a$labelStack = a.labelStack) !== null && _a$labelStack !== void 0 ? _a$labelStack : [], labelStack)) return;
        if (a.stopTime > interaction.start && ((_earliestLegacyStopTi = earliestLegacyStopTime) !== null && _earliestLegacyStopTi !== void 0 ? _earliestLegacyStopTi : a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function $72d68f2fee0a7403$var$getBm3EndTimeOrFallbackValue(interaction) {
    var _getEarliestLegacySto;
    var labelStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : interaction.end;
    if (interaction.type === 'press') return fallbackValue;
    return (_getEarliestLegacySto = $72d68f2fee0a7403$var$getEarliestLegacyStopTime(interaction, labelStack)) !== null && _getEarliestLegacySto !== void 0 ? _getEarliestLegacySto : fallbackValue;
}
var $72d68f2fee0a7403$var$getPageVisibilityUpToTTI = function getPageVisibilityUpToTTI(interaction) {
    var start = interaction.start;
    var bm3EndTimeOrInteractionEndTime = $72d68f2fee0a7403$var$getBm3EndTimeOrFallbackValue(interaction);
    return (0, $4gtBF.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
};
var $72d68f2fee0a7403$var$getPageVisibilityUpToTTAI = function getPageVisibilityUpToTTAI(interaction) {
    var start = interaction.start, end = interaction.end;
    return (0, $4gtBF.getPageVisibilityState)(start, end);
};
var $72d68f2fee0a7403$var$getVisibilityStateFromPerformance = function getVisibilityStateFromPerformance(stop) {
    try {
        var results = performance.getEntriesByType('visibility-state');
        if (!results || results.length === 0) return null;
        return results.reduce(function() {
            var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var _ref = arguments.length > 1 ? arguments[1] : undefined, name = _ref.name, startTime = _ref.startTime;
            if (startTime > stop) return acc;
            if (acc === null && name === null) return null;
            if (acc === null) return name;
            if (acc !== name) return 'mixed';
            return acc;
        }, null);
    } catch (e) {
        return null;
    }
};
var $72d68f2fee0a7403$var$getMoreAccuratePageVisibilityUpToTTI = function getMoreAccuratePageVisibilityUpToTTI(interaction) {
    var old = $72d68f2fee0a7403$var$getPageVisibilityUpToTTI(interaction);
    var tti = $72d68f2fee0a7403$var$getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    var buffered = $72d68f2fee0a7403$var$getVisibilityStateFromPerformance(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
};
var $72d68f2fee0a7403$var$getMoreAccuratePageVisibilityUpToTTAI = function getMoreAccuratePageVisibilityUpToTTAI(interaction) {
    var old = $72d68f2fee0a7403$var$getPageVisibilityUpToTTAI(interaction);
    var buffered = $72d68f2fee0a7403$var$getVisibilityStateFromPerformance(interaction.end);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
};
var $72d68f2fee0a7403$var$getInteractionStatus = function getInteractionStatus(interaction) {
    var originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    var hasBm3TTI = interaction.apdex.length > 0;
    var overrideStatus = hasBm3TTI ? 'SUCCEEDED' : originalInteractionStatus;
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: overrideStatus
    };
};
var $72d68f2fee0a7403$var$getResourceTimings = function getResourceTimings(start, end) {
    var _resourceTiming$getRe;
    return (_resourceTiming$getRe = $d39M6.getResourceTimings(start, end)) !== null && _resourceTiming$getRe !== void 0 ? _resourceTiming$getRe : undefined;
};
var $72d68f2fee0a7403$var$getBundleEvalTimings = function getBundleEvalTimings(start) {
    return $jS0DY.getBundleEvalTimings(start);
};
var $72d68f2fee0a7403$var$getSSRSuccess = function getSSRSuccess(type) {
    return type === 'page_load' ? $1CoTB.getSSRSuccess() : undefined;
};
var $72d68f2fee0a7403$var$getSSRFeatureFlags = function getSSRFeatureFlags(type) {
    return type === 'page_load' ? $1CoTB.getSSRFeatureFlags() : undefined;
};
var $72d68f2fee0a7403$var$getPaintMetrics = function getPaintMetrics(type) {
    if (type !== 'page_load') return {};
    var metrics = {};
    performance.getEntriesByType('paint').forEach(function(entry) {
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};
var $72d68f2fee0a7403$var$getTTAI = function getTTAI(interaction) {
    var start = interaction.start, end = interaction.end;
    var pageVisibilityUpToTTAI = $72d68f2fee0a7403$var$getPageVisibilityUpToTTAI(interaction);
    return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
};
var $72d68f2fee0a7403$var$getVCMetrics = function getVCMetrics(interaction) {
    var _config$vc, _config$vc$ssrWhiteli, _interaction$apdex, _config$experimentalI;
    var config = (0, $03EZb.getConfig)();
    if (!(config !== null && config !== void 0 && (_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled)) return {};
    if (interaction.type !== 'page_load' && interaction.type !== 'transition') return {};
    var isSSREnabled = (config === null || config === void 0 ? void 0 : config.ssr) || (config === null || config === void 0 || (_config$vc$ssrWhiteli = config.vc.ssrWhitelist) === null || _config$vc$ssrWhiteli === void 0 ? void 0 : _config$vc$ssrWhiteli.includes(interaction.ufoName));
    var ssr = interaction.type === 'page_load' && isSSREnabled ? {
        ssr: $72d68f2fee0a7403$var$getSSRDoneTimeValue(config)
    } : null;
    (0, $a48Mt.postInteractionLog).setVCObserverSSRConfig(ssr);
    var tti = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime;
    var prefix = 'ufo';
    var result = (0, $4PhwH.getVCObserver)().getVCResult($72d68f2fee0a7403$var$_objectSpread({
        start: interaction.start,
        stop: interaction.end,
        tti: tti,
        prefix: prefix,
        vc: interaction.vc
    }, ssr));
    if ((_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) (0, $4PhwH.getVCObserver)().stop();
    (0, $a48Mt.postInteractionLog).setLastInteractionFinishVCResult(result);
    var VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
    if (!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")])) return result;
    var interactionStatus = $72d68f2fee0a7403$var$getInteractionStatus(interaction);
    var pageVisibilityUpToTTAI = $72d68f2fee0a7403$var$getPageVisibilityUpToTTAI(interaction);
    if (interactionStatus.originalInteractionStatus !== 'SUCCEEDED' || pageVisibilityUpToTTAI !== 'visible') return result;
    if ((0, $39c3M.fg)('ufo_vc_multiheatmap')) {
        var _result;
        (_result = result["".concat(prefix, ":vc:rev")]) === null || _result === void 0 || _result.forEach(function(element) {
            var _element$vcDetails;
            if ((_element$vcDetails = element.vcDetails) !== null && _element$vcDetails !== void 0 && (_element$vcDetails = _element$vcDetails['90']) !== null && _element$vcDetails !== void 0 && _element$vcDetails.t) {
                var _element$vcDetails$;
                element['metric:vc90'] = (_element$vcDetails$ = element.vcDetails['90']) === null || _element$vcDetails$ === void 0 ? void 0 : _element$vcDetails$.t;
            }
        });
    }
    return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, result), {}, {
        'metric:vc90': VC['90']
    });
};
var $72d68f2fee0a7403$var$getNavigationMetrics = function getNavigationMetrics(type) {
    if (type !== 'page_load') return {};
    var entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return {};
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart),
        nextHopProtocol: navigation.nextHopProtocol
    };
    return {
        'metrics:navigation': metrics
    };
};
var $72d68f2fee0a7403$var$getPPSMetrics = function getPPSMetrics(interaction) {
    var _interaction$apdex2;
    var start = interaction.start, end = interaction.end;
    var config = (0, $03EZb.getConfig)();
    var interactionStatus = $72d68f2fee0a7403$var$getInteractionStatus(interaction);
    var pageVisibilityUpToTTAI = $72d68f2fee0a7403$var$getPageVisibilityUpToTTAI(interaction);
    var tti = (_interaction$apdex2 = interaction.apdex) === null || _interaction$apdex2 === void 0 || (_interaction$apdex2 = _interaction$apdex2[0]) === null || _interaction$apdex2 === void 0 ? void 0 : _interaction$apdex2.stopTime;
    var ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    var PPSMetricsAtTTI = tti !== undefined ? (0, $ceERr.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    var PPSMetricsAtTTAI = ttai !== undefined ? (0, $ceERr.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if (config !== null && config !== void 0 && config.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    if (PPSMetricsAtTTI !== null) return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, PPSMetricsAtTTI), {}, {
        'metrics@ttai': PPSMetricsAtTTAI
    });
    return {};
};
function $72d68f2fee0a7403$var$getSSRProperties(type) {
    return {
        'ssr:success': $72d68f2fee0a7403$var$getSSRSuccess(type),
        'ssr:featureFlags': $72d68f2fee0a7403$var$getSSRFeatureFlags(type)
    };
}
var $72d68f2fee0a7403$var$getAssetsMetrics = function getAssetsMetrics(interaction, resourceTimings) {
    try {
        var config = (0, $03EZb.getConfig)();
        var type = interaction.type;
        var allowedTypes = [
            'page_load',
            'transition'
        ];
        var assetsClassification = config === null || config === void 0 ? void 0 : config.assetsClassification;
        if (!allowedTypes.includes(type) || !assetsClassification) // Skip if: type not allowed or assetsClassification isn't configured
        return {};
        var reporter = new (0, $cH3JV.CHRReporter)();
        var assets = reporter.get(resourceTimings, assetsClassification);
        if (assets) // Only add assets in case it exists
        return {
            'event:assets': assets
        };
        return {};
    } catch (error) {
        // Skip CHR in case of error
        return {};
    }
};
var $72d68f2fee0a7403$var$getBrowserMetadata = function getBrowserMetadata() {
    var data = {};
    var now = new Date();
    data['event:localHour'] = now.getHours(); // returns the hours for this date according to local time
    data['event:localDayOfWeek'] = now.getDay(); // Sunday - Saturday : 0 - 6
    data['event:localTimezoneOffset'] = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (navigator.userAgent != null) {
        var browser = (0, (/*@__PURE__*/$parcel$interopDefault($8oqW7))).getParser(navigator.userAgent);
        data['event:browser:name'] = browser.getBrowserName();
        data['event:browser:version'] = browser.getBrowserVersion();
    }
    if (navigator.hardwareConcurrency != null) data['event:cpus'] = navigator.hardwareConcurrency;
    if (navigator.deviceMemory != null) data['event:memory'] = navigator.deviceMemory;
    // eslint-disable-next-line compat/compat
    if (navigator.connection != null) {
        data['event:network:effectiveType'] = navigator.connection.effectiveType;
        data['event:network:rtt'] = navigator.connection.rtt;
        data['event:network:downlink'] = navigator.connection.downlink;
    }
    return data;
};
var $72d68f2fee0a7403$var$getTracingContextData = function getTracingContextData(interaction) {
    var trace = interaction.trace, start = interaction.start;
    var tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
};
function $72d68f2fee0a7403$var$optimizeCustomData(interaction) {
    var customData = interaction.customData, legacyMetrics = interaction.legacyMetrics;
    var customDataMap = customData.reduce(function(result, _ref2) {
        var _result$get$data, _result$get;
        var labelStack = _ref2.labelStack, data = _ref2.data;
        var label = (0, $hij2V.stringifyLabelStackFully)(labelStack);
        var value = (_result$get$data = (_result$get = result.get(label)) === null || _result$get === void 0 ? void 0 : _result$get.data) !== null && _result$get$data !== void 0 ? _result$get$data : {};
        result.set(label, {
            labelStack: (0, $hij2V.optimizeLabelStack)(labelStack),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    if (legacyMetrics) {
        var legacyMetricsFiltered = legacyMetrics.filter(function(item) {
            return item.type === 'PAGE_LOAD';
        }).reduce(function(result, currentValue) {
            for(var _i = 0, _Object$entries = Object.entries(currentValue.custom || {}); _i < _Object$entries.length; _i++){
                var _result$get$data2, _result$get2;
                var _Object$entries$_i = (0, $6HNZJ.default)(_Object$entries[_i], 2), _key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                var label = (0, $hij2V.stringifyLabelStackFully)([]);
                var labelValue = (_result$get$data2 = (_result$get2 = result.get(label)) === null || _result$get2 === void 0 ? void 0 : _result$get2.data) !== null && _result$get$data2 !== void 0 ? _result$get$data2 : {};
                result.set(label, {
                    labelStack: (0, $hij2V.optimizeLabelStack)([]),
                    data: Object.assign(labelValue, (0, $gNkVH.default)({}, _key, value))
                });
            }
            return result;
        }, new Map());
        return [].concat((0, $kOzMB.default)(customDataMap.values()), (0, $kOzMB.default)(legacyMetricsFiltered.values()));
    }
    return (0, $kOzMB.default)(customDataMap.values());
}
function $72d68f2fee0a7403$var$optimizeReactProfilerTimings(reactProfilerTimings, interactionStart) {
    var reactProfilerTimingsMap = reactProfilerTimings.reduce(function(result, _ref3) {
        var labelStack = _ref3.labelStack, startTime = _ref3.startTime, commitTime = _ref3.commitTime, actualDuration = _ref3.actualDuration, type = _ref3.type;
        if (labelStack && startTime >= interactionStart) {
            var label = (0, $hij2V.stringifyLabelStackFully)(labelStack);
            var start = Math.round(startTime);
            var end = Math.round(commitTime);
            var timing = result.get(label) || {
                labelStack: (0, $hij2V.optimizeLabelStack)(labelStack),
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 0,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = start;
            if (end > timing.endTime) timing.endTime = end;
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, $kOzMB.default)(reactProfilerTimingsMap.values());
}
function $72d68f2fee0a7403$var$optimizeRedirects(redirects, interactionStart) {
    var lastRedirectTime = interactionStart;
    var updatedRedirects = redirects.sort(function(a, b) {
        return a.time - b.time;
    }).reduce(function(result, redirect) {
        var fromInteractionName = redirect.fromInteractionName, time = redirect.time;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function $72d68f2fee0a7403$var$optimizeHoldInfo(holdInfo, interactionStart) {
    var holdInfoMap = holdInfo.reduce(function(result, hold) {
        var labelStack = hold.labelStack, name = hold.name, start = hold.start, end = hold.end, ignoreOnSubmit = hold.ignoreOnSubmit;
        if (labelStack && !ignoreOnSubmit && start >= interactionStart) {
            var label = (0, $hij2V.stringifyLabelStackFully)([].concat((0, $kOzMB.default)(labelStack), [
                {
                    name: name
                }
            ]));
            var startTime = Math.round(start);
            var endTime = Math.round(end);
            var timing = result.get(label) || {
                labelStack: (0, $hij2V.optimizeLabelStack)([].concat((0, $kOzMB.default)(labelStack), [
                    {
                        name: name
                    }
                ])),
                startTime: startTime,
                endTime: endTime
            };
            if (startTime < timing.startTime) timing.startTime = startTime;
            if (endTime > timing.endTime) timing.endTime = endTime;
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, $kOzMB.default)(holdInfoMap.values());
}
function $72d68f2fee0a7403$var$optimizeSpans(spans, interactionStart) {
    var updatedSpans = spans.reduce(function(result, span) {
        var labelStack = span.labelStack, type = span.type, name = span.name, start = span.start, end = span.end;
        if (labelStack && start >= interactionStart) result.push({
            labelStack: (0, $hij2V.optimizeLabelStack)([].concat((0, $kOzMB.default)(labelStack), [
                {
                    name: name
                }
            ])),
            startTime: Math.round(start),
            endTime: Math.round(end),
            type: type
        });
        return result;
    }, []);
    return updatedSpans;
}
function $72d68f2fee0a7403$var$optimizeRequestInfo(requestInfo, interactionStart) {
    var updatedRequestInfo = requestInfo.reduce(function(result, reqInfo) {
        var labelStack = reqInfo.labelStack, name = reqInfo.name, start = reqInfo.start, end = reqInfo.end, networkStart = reqInfo.networkStart, networkComplete = reqInfo.networkComplete;
        var startTime = networkStart !== null && networkStart !== void 0 ? networkStart : start;
        var endTime = networkComplete !== null && networkComplete !== void 0 ? networkComplete : end;
        if (labelStack && start >= interactionStart && endTime) result.push({
            labelStack: (0, $hij2V.optimizeLabelStack)([].concat((0, $kOzMB.default)(labelStack), [
                {
                    name: name
                }
            ])),
            startTime: Math.round(startTime),
            endTime: Math.round(endTime)
        });
        return result;
    }, []);
    return updatedRequestInfo;
}
function $72d68f2fee0a7403$var$optimizeCustomTimings(customTimings, interactionStart) {
    return customTimings.reduce(function(result, item) {
        Object.keys(item.data).forEach(function(key) {
            if (item.data[key].startTime >= interactionStart) result.push({
                labelStack: [
                    {
                        n: key
                    }
                ],
                startTime: Math.round(item.data[key].startTime),
                endTime: Math.round(item.data[key].endTime)
            });
        });
        return result;
    }, []);
}
function $72d68f2fee0a7403$var$optimizeMarks(marks) {
    return marks.map(function(_ref4) {
        var labelStack = _ref4.labelStack, time = _ref4.time, others = (0, $lrM5r.default)(_ref4, $72d68f2fee0a7403$var$_excluded);
        return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, others), {}, {
            labelStack: labelStack && (0, $hij2V.optimizeLabelStack)(labelStack),
            time: Math.round(time)
        });
    });
}
function $72d68f2fee0a7403$var$optimizeApdex(apdex) {
    return apdex.map(function(_ref5) {
        var stopTime = _ref5.stopTime, labelStack = _ref5.labelStack, others = (0, $lrM5r.default)(_ref5, $72d68f2fee0a7403$var$_excluded2);
        return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, others), {}, {
            stopTime: Math.round(stopTime)
        }, labelStack ? {
            labelStack: (0, $hij2V.optimizeLabelStack)(labelStack)
        } : {});
    });
}
function $72d68f2fee0a7403$var$objectToArray() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(obj).reduce(function(result, key) {
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, []);
}
function $72d68f2fee0a7403$var$getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    var submetricsTimings = submetrics.filter(function(item) {
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map(function(item) {
        var childSubmetrics;
        var newKey = "include/".concat(item.key);
        if (item.submetrics) childSubmetrics = $72d68f2fee0a7403$var$getBM3SubmetricsTimings(item.submetrics);
        return $72d68f2fee0a7403$var$_objectSpread((0, $gNkVH.default)({}, newKey, {
            endTime: item.stop - item.start,
            startTime: item.start
        }), childSubmetrics ? childSubmetrics : {});
    });
    return submetricsTimings;
}
function $72d68f2fee0a7403$var$getBm3TrackerTimings(interaction) {
    var interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    var legacyMetrics = interactionLegacyMetrics.map(function(item) {
        var _item$config, _item$config2, _item$marks;
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: (_item$config = item.config) === null || _item$config === void 0 ? void 0 : _item$config.type,
            reactUFOName: (_item$config2 = item.config) === null || _item$config2 === void 0 ? void 0 : _item$config2.reactUFOName,
            fmp: ((_item$marks = item.marks) === null || _item$marks === void 0 ? void 0 : _item$marks['fmp']) || item.stop,
            source: 'bm3',
            timings: (0, $bUAr3.getBm3Timings)(item.marks, item.config.timings),
            submetrics: $72d68f2fee0a7403$var$getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter(function(item) {
        return !!item.type;
    });
    return {
        legacyMetrics: legacyMetrics
    };
}
function $72d68f2fee0a7403$var$getSSRDoneTimeValue(config) {
    var _config$ssr, _config$ssr2;
    return config !== null && config !== void 0 && (_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getSSRDoneTime ? config === null || config === void 0 || (_config$ssr2 = config.ssr) === null || _config$ssr2 === void 0 ? void 0 : _config$ssr2.getSSRDoneTime() : $1CoTB.getSSRDoneTime();
}
function $72d68f2fee0a7403$var$getPayloadSize(payload) {
    return Math.round(new TextEncoder().encode(JSON.stringify(payload)).length / 1024);
}
function $72d68f2fee0a7403$var$getStylesheetMetrics() {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (!(0, $39c3M.fg)('ufo_capture_stylesheet_metrics')) return {};
    try {
        var stylesheets = Array.from(document.styleSheets);
        var stylesheetCount = stylesheets.length;
        var cssrules = Array.from(document.styleSheets).reduce(function(acc, item) {
            // Other domain stylesheets throw a SecurityError
            try {
                return acc + item.cssRules.length;
            } catch (e) {
                return acc;
            }
        }, 0);
        var styleElements = document.querySelectorAll('style').length;
        var styleProps = document.querySelectorAll('[style]');
        var styleDeclarations = Array.from(document.querySelectorAll('[style]')).reduce(function(acc, item) {
            try {
                if ('style' in item) return acc + item.style.length;
                else return acc;
            } catch (e) {
                return acc;
            }
        }, 0);
        return {
            'ufo:stylesheets': stylesheetCount,
            'ufo:styleElements': styleElements,
            'ufo:styleProps': styleProps.length,
            'ufo:styleDeclarations': styleDeclarations,
            'ufo:cssrules': cssrules
        };
    } catch (e) {
        return {};
    }
}
var $72d68f2fee0a7403$var$regularTTAI;
var $72d68f2fee0a7403$var$expTTAI;
function $72d68f2fee0a7403$var$getErrorCounts(interaction) {
    return {
        'ufo:errors:globalCount': (0, $bLOdU.getGlobalErrorCount)(),
        'ufo:errors:count': interaction.errors.length
    };
}
function $72d68f2fee0a7403$var$createInteractionMetricsPayload(interaction, interactionId, experimental) {
    var _window$location, _config$additionalPay;
    var interactionPayloadStart = performance.now();
    var config = (0, $03EZb.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    var end = interaction.end, start = interaction.start, ufoName = interaction.ufoName, knownSegments = interaction.knownSegments, rate = interaction.rate, type = interaction.type, abortReason = interaction.abortReason, routeName = interaction.routeName, featureFlags = interaction.featureFlags, previousInteractionName = interaction.previousInteractionName, isPreviousInteractionAborted = interaction.isPreviousInteractionAborted, abortedByInteractionName = interaction.abortedByInteractionName;
    var pageVisibilityAtTTI = $72d68f2fee0a7403$var$getPageVisibilityUpToTTI(interaction);
    var pageVisibilityAtTTAI = $72d68f2fee0a7403$var$getPageVisibilityUpToTTAI(interaction);
    var segments = config.killswitchNestedSegments ? [] : knownSegments;
    var segmentTree = (0, $geLu7.REACT_UFO_VERSION) === '2.0.0' ? (0, $hij2V.buildSegmentTree)(segments.map(function(segment) {
        return segment.labelStack;
    })) : {};
    var isDetailedPayload = pageVisibilityAtTTAI === 'visible';
    var isPageLoad = type === 'page_load';
    var calculatePageVisibilityFromTheStartOfPageLoad = config.enableBetterPageVisibilityApi && isPageLoad;
    var moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $72d68f2fee0a7403$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
    var moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? $72d68f2fee0a7403$var$getMoreAccuratePageVisibilityUpToTTAI(interaction) : null;
    var labelStack = interaction.labelStack ? {
        labelStack: (0, $hij2V.optimizeLabelStack)(interaction.labelStack)
    } : {};
    // Page Load
    var getPageLoadInteractionMetrics = function getPageLoadInteractionMetrics() {
        var _config$ssr3;
        if (!isPageLoad) return {};
        var config = (0, $03EZb.getConfig)();
        var SSRDoneTimeValue = $72d68f2fee0a7403$var$getSSRDoneTimeValue(config);
        var SSRDoneTime = SSRDoneTimeValue !== undefined ? {
            SSRDoneTime: Math.round(SSRDoneTimeValue)
        } : {};
        return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, SSRDoneTime), {}, {
            isBM3ConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp,
            isUFOConfigSSRDoneAsFmp: interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!(config !== null && config !== void 0 && (_config$ssr3 = config.ssr) !== null && _config$ssr3 !== void 0 && _config$ssr3.getSSRDoneTime)
        });
    };
    // Detailed payload. Page visibility = visible
    var getDetailedInteractionMetrics = function getDetailedInteractionMetrics(resourceTimings) {
        if (experimental || window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
        var spans = [].concat((0, $kOzMB.default)(interaction.spans), (0, $kOzMB.default)((0, $a48Mt.interactionSpans)));
        (0, $a48Mt.interactionSpans).length = 0;
        return {
            errors: interaction.errors.map(function(_ref6) {
                var labelStack = _ref6.labelStack, others = (0, $lrM5r.default)(_ref6, $72d68f2fee0a7403$var$_excluded3);
                return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, others), {}, {
                    labelStack: labelStack && (0, $hij2V.optimizeLabelStack)(labelStack)
                });
            }),
            holdActive: (0, $kOzMB.default)(interaction.holdActive.values()),
            redirects: $72d68f2fee0a7403$var$optimizeRedirects(interaction.redirects, start),
            holdInfo: $72d68f2fee0a7403$var$optimizeHoldInfo(experimental ? interaction.holdExpInfo : interaction.holdInfo, start),
            spans: $72d68f2fee0a7403$var$optimizeSpans(spans, start),
            requestInfo: $72d68f2fee0a7403$var$optimizeRequestInfo(interaction.requestInfo, start),
            customTimings: $72d68f2fee0a7403$var$optimizeCustomTimings(interaction.customTimings, start),
            bundleEvalTimings: $72d68f2fee0a7403$var$objectToArray($72d68f2fee0a7403$var$getBundleEvalTimings(start)),
            resourceTimings: $72d68f2fee0a7403$var$objectToArray(resourceTimings)
        };
    };
    // Page load & detailed payload
    var getPageLoadDetailedInteractionMetrics = function getPageLoadDetailedInteractionMetrics() {
        var _config$ssr4;
        if (!isPageLoad || !isDetailedPayload) return {};
        var config = (0, $03EZb.getConfig)();
        return {
            initialPageLoadExtraTimings: $72d68f2fee0a7403$var$objectToArray($8pUKJ.getTimings()),
            SSRTimings: config !== null && config !== void 0 && (_config$ssr4 = config.ssr) !== null && _config$ssr4 !== void 0 && _config$ssr4.getSSRTimings ? config.ssr.getSSRTimings() : $72d68f2fee0a7403$var$objectToArray($1CoTB.getSSRTimings())
        };
    };
    if (experimental) $72d68f2fee0a7403$var$expTTAI = $72d68f2fee0a7403$var$getTTAI(interaction);
    else $72d68f2fee0a7403$var$regularTTAI = $72d68f2fee0a7403$var$getTTAI(interaction);
    var newUFOName = (0, $hij2V.sanitizeUfoName)(ufoName);
    var resourceTimings = $72d68f2fee0a7403$var$getResourceTimings(start, end);
    var payload = {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({
                // basic
                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:sizeInKb': 0,
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $geLu7.REACT_UFO_VERSION),
                    payloadSource: 'platform'
                },
                'event:region': config.region || 'unknown',
                'experience:key': experimental ? 'custom.experimental-interaction-metrics' : 'custom.interaction-metrics',
                'experience:name': newUFOName
            }, $72d68f2fee0a7403$var$getBrowserMetadata()), $72d68f2fee0a7403$var$getSSRProperties(type)), $72d68f2fee0a7403$var$getAssetsMetrics(interaction, resourceTimings)), $72d68f2fee0a7403$var$getPPSMetrics(interaction)), $72d68f2fee0a7403$var$getPaintMetrics(type)), $72d68f2fee0a7403$var$getNavigationMetrics(type)), $72d68f2fee0a7403$var$getVCMetrics(interaction)), experimental ? (0, $f3CCR.getExperimentalVCMetrics)(interaction) : undefined), (_config$additionalPay = config.additionalPayloadData) === null || _config$additionalPay === void 0 ? void 0 : _config$additionalPay.call(config, interaction)), $72d68f2fee0a7403$var$getTracingContextData(interaction)), $72d68f2fee0a7403$var$getStylesheetMetrics()), $72d68f2fee0a7403$var$getErrorCounts(interaction)), {}, {
                interactionMetrics: $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({
                    namePrefix: config.namePrefix || '',
                    segmentPrefix: config.segmentPrefix || '',
                    interactionId: interactionId,
                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                    // raw interaction metrics
                    rate: rate,
                    routeName: routeName,
                    type: type,
                    abortReason: abortReason,
                    featureFlags: featureFlags,
                    previousInteractionName: previousInteractionName,
                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                    abortedByInteractionName: abortedByInteractionName,
                    // performance
                    apdex: $72d68f2fee0a7403$var$optimizeApdex(interaction.apdex),
                    end: Math.round(end),
                    start: Math.round(start),
                    segments: (0, $geLu7.REACT_UFO_VERSION) === '2.0.0' ? segmentTree : segments.map(function(_ref7) {
                        var labelStack = _ref7.labelStack, others = (0, $lrM5r.default)(_ref7, $72d68f2fee0a7403$var$_excluded4);
                        return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, others), {}, {
                            labelStack: (0, $hij2V.optimizeLabelStack)(labelStack)
                        });
                    }),
                    marks: $72d68f2fee0a7403$var$optimizeMarks(interaction.marks),
                    customData: $72d68f2fee0a7403$var$optimizeCustomData(interaction),
                    reactProfilerTimings: $72d68f2fee0a7403$var$optimizeReactProfilerTimings(interaction.reactProfilerTimings, start)
                }, labelStack), getPageLoadInteractionMetrics()), getDetailedInteractionMetrics(resourceTimings)), getPageLoadDetailedInteractionMetrics()), $72d68f2fee0a7403$var$getBm3TrackerTimings(interaction)), {}, {
                    'metric:ttai': experimental ? $72d68f2fee0a7403$var$regularTTAI || $72d68f2fee0a7403$var$expTTAI : undefined,
                    'metric:experimental:ttai': $72d68f2fee0a7403$var$expTTAI
                }),
                'ufo:payloadTime': (0, $87kDd.roundEpsilon)(performance.now() - interactionPayloadStart)
            })
        }
    };
    if (experimental) {
        $72d68f2fee0a7403$var$regularTTAI = undefined;
        $72d68f2fee0a7403$var$expTTAI = undefined;
    }
    payload.attributes.properties['event:sizeInKb'] = $72d68f2fee0a7403$var$getPayloadSize(payload.attributes.properties);
    return payload;
}
function $72d68f2fee0a7403$export$51b606e6d67c2231(interactionId, interaction) {
    var ufoNameOverride = $72d68f2fee0a7403$var$getUfoNameOverride(interaction);
    var modifiedInteraction = $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, interaction), {}, {
        ufoName: ufoNameOverride
    });
    var interactionMetricsPayload = $72d68f2fee0a7403$var$createInteractionMetricsPayload(modifiedInteraction, interactionId);
    return [
        interactionMetricsPayload
    ];
}
function $72d68f2fee0a7403$export$6410c9ddb2ab201(interactionId, interaction) {
    var config = (0, $03EZb.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    var ufoName = (0, $hij2V.sanitizeUfoName)(interaction.ufoName);
    var rate = (0, $03EZb.getExperimentalInteractionRate)(ufoName, interaction.type);
    if (!(0, $as5v9.default)(rate)) return null;
    var pageVisibilityState = (0, $4gtBF.getPageVisibilityState)(interaction.start, interaction.end);
    if (pageVisibilityState !== 'visible') return null;
    return $72d68f2fee0a7403$var$createInteractionMetricsPayload(interaction, interactionId, true);
}

});
parcelRegister("cH3JV", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", function () { return $93dc66d3ece79437$export$7d0d4cfb6455ffa5; });

var $6HNZJ = parcelRequire("6HNZJ");

var $zhrfT = parcelRequire("zhrfT");

var $j9c2S = parcelRequire("j9c2S");

var $gNkVH = parcelRequire("gNkVH");

var $22DFS = parcelRequire("22DFS");
var $93dc66d3ece79437$export$783d6618ee601ba = /*#__PURE__*/ function() {
    function CHRSummary() {
        (0, $zhrfT.default)(this, CHRSummary);
        (0, $gNkVH.default)(this, "bundles", (0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)({}, (0, $22DFS.MEMORY_KEY), 0), (0, $22DFS.DISK_KEY), 0), (0, $22DFS.NETWORK_KEY), 0));
        (0, $gNkVH.default)(this, "bundlesCount", 0);
        (0, $gNkVH.default)(this, "size", (0, $gNkVH.default)((0, $gNkVH.default)((0, $gNkVH.default)({}, (0, $22DFS.MEMORY_KEY), 0), (0, $22DFS.DISK_KEY), 0), (0, $22DFS.NETWORK_KEY), 0));
        (0, $gNkVH.default)(this, "sizeTotal", 0);
    }
    return (0, $j9c2S.default)(CHRSummary, [
        {
            key: "add",
            value: function add(asset) {
                var size = 'size' in asset ? asset.size : undefined;
                var encodedSize = 'encodedSize' in asset ? Number(asset.encodedSize) : 0;
                var type = (0, $22DFS.calculateTransferType)(asset.type, asset.duration, size);
                if (type === null) return;
                this.bundles[type] += 1;
                this.bundlesCount += 1;
                this.size[type] += encodedSize;
                this.sizeTotal += encodedSize;
            }
        }
    ], [
        {
            key: "makePayload",
            value: function makePayload(summary) {
                var size = summary.size, bundlesCount = summary.bundlesCount, sizeTotal = summary.sizeTotal;
                var cachedSize = size[0, $22DFS.MEMORY_KEY] + size[0, $22DFS.DISK_KEY];
                var sizeRatio = (0, $22DFS.round)(cachedSize / summary.sizeTotal);
                return {
                    size: sizeTotal,
                    chr: sizeRatio,
                    count: bundlesCount
                };
            }
        }
    ]);
}();
var $93dc66d3ece79437$export$7d0d4cfb6455ffa5 = /*#__PURE__*/ function() {
    function CHRReporter() {
        (0, $zhrfT.default)(this, CHRReporter);
        (0, $gNkVH.default)(this, "all", new $93dc66d3ece79437$export$783d6618ee601ba());
        (0, $gNkVH.default)(this, "allAtlassian", new $93dc66d3ece79437$export$783d6618ee601ba());
        (0, $gNkVH.default)(this, "preloaded", new $93dc66d3ece79437$export$783d6618ee601ba());
    }
    return (0, $j9c2S.default)(CHRReporter, [
        {
            key: "get",
            value: function get(resourceTimings, assetsClassification) {
                var _this = this;
                try {
                    Object.entries(resourceTimings).map(function(_ref) {
                        var _ref2 = (0, $6HNZJ.default)(_ref, 2), label = _ref2[0], entry = _ref2[1];
                        if (assetsClassification.all) _this.all.add(entry);
                        if (assetsClassification.allAtlassian({
                            label: label,
                            entry: entry
                        })) _this.allAtlassian.add(entry);
                        if (assetsClassification.preloaded({
                            label: label,
                            entry: entry
                        })) _this.preloaded.add(entry);
                    });
                    if (this.all.bundlesCount === 0) return null;
                    return {
                        all: $93dc66d3ece79437$export$783d6618ee601ba.makePayload(this.all),
                        allAtlassian: $93dc66d3ece79437$export$783d6618ee601ba.makePayload(this.allAtlassian),
                        preloaded: $93dc66d3ece79437$export$783d6618ee601ba.makePayload(this.preloaded)
                    };
                } catch (error) {
                    return null;
                }
            }
        }
    ]);
}();

});
parcelRegister("22DFS", function(module, exports) {
$parcel$export(module.exports, "MEMORY_KEY", function () { return $17ca8b31d137726c$export$22f4983702ea2cc3; });
$parcel$export(module.exports, "DISK_KEY", function () { return $17ca8b31d137726c$export$d85e88075ae28804; });
$parcel$export(module.exports, "NETWORK_KEY", function () { return $17ca8b31d137726c$export$c46019be3f2161d7; });
$parcel$export(module.exports, "calculateTransferType", function () { return $17ca8b31d137726c$export$82deef6698791e4e; });
$parcel$export(module.exports, "round", function () { return $17ca8b31d137726c$export$2077e0241d6afd3c; });
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ var $17ca8b31d137726c$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];
var $17ca8b31d137726c$export$22f4983702ea2cc3 = 'mem';
var $17ca8b31d137726c$export$d85e88075ae28804 = 'disk';
var $17ca8b31d137726c$export$c46019be3f2161d7 = 'net';
var $17ca8b31d137726c$export$82deef6698791e4e = function calculateTransferType(type, duration, size) {
    if (!$17ca8b31d137726c$export$5e1aa91d6932ddaa.includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $17ca8b31d137726c$export$22f4983702ea2cc3;
    if (size === 0 && duration > 0) return $17ca8b31d137726c$export$d85e88075ae28804;
    if (size === undefined) return null;
    return $17ca8b31d137726c$export$c46019be3f2161d7;
};
var $17ca8b31d137726c$export$2077e0241d6afd3c = function round(n) {
    if (isNaN(n)) return 0;
    return Math.round(n * 10000) / 10000;
};

});


parcelRegister("jS0DY", function(module, exports) {
$parcel$export(module.exports, "getBundleEvalTimings", function () { return $e7738f4dc0946387$export$2eda1519e91a4386; });

var $87kDd = parcelRequire("87kDd");
var $e7738f4dc0946387$var$config = null;
function $e7738f4dc0946387$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $e7738f4dc0946387$var$config = bundleEvalTimingConfiguration;
}
var $e7738f4dc0946387$var$getPerformanceObject = function getPerformanceObject() {
    var _window;
    return ((_window = window) !== null && _window !== void 0 ? _window : {}).performance;
};
function $e7738f4dc0946387$export$2eda1519e91a4386(interactionStartTime) {
    if ($e7738f4dc0946387$var$config == null) return {};
    var started = {};
    var timings = {};
    var cachedConfig = $e7738f4dc0946387$var$config;
    var performance = $e7738f4dc0946387$var$getPerformanceObject();
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach(function(mark) {
        var result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $87kDd.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $87kDd.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("87kDd", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", function () { return $5e8efb2d16b82543$export$56014375de40214b; });
var $5e8efb2d16b82543$export$56014375de40214b = function roundEpsilon(num) {
    var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

});


parcelRegister("geLu7", function(module, exports) {
$parcel$export(module.exports, "REACT_UFO_VERSION", function () { return $bd22c9a81d6634c7$export$4cbfa0cbc1d9a512; });

var $39c3M = parcelRequire("39c3M");
var $bd22c9a81d6634c7$export$4cbfa0cbc1d9a512 = (0, $39c3M.fg)('enable-react-ufo-payload-segment-compressed') ? '2.0.0' : '1.0.1';

});

parcelRegister("bUAr3", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", function () { return $8ac12ff4b6836583$export$f02972da195a43bb; });

var $gljCV = parcelRequire("gljCV");

var $iqOwP = parcelRequire("iqOwP");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");
function $8ac12ff4b6836583$export$f02972da195a43bb(marks, timingConfigs) {
    var bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach(function(item) {
        if (!item.startMark || !item.endMark) return;
        var startTime = marks[item.startMark];
        if (!startTime) return;
        var endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8ac12ff4b6836583$export$30f0b5e5acd268bf(_ref) {
    var marks = _ref.marks, timings = _ref.timings;
    var interactionContext = (0, $gljCV.useContext)((0, $iqOwP.default));
    var interactionId = (0, $1BTY2.getInteractionId)().current;
    (0, $gljCV.useMemo)(function() {
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            var interactionType = (0, $a48Mt.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            var bm3Timings = $8ac12ff4b6836583$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8ac12ff4b6836583$export$d93d677ef2f33c5c(marks, timingsConfig) {
    var interactionId = (0, $1BTY2.getInteractionId)().current;
    if (interactionId) {
        var interactionType = (0, $a48Mt.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        var bm3Timings = $8ac12ff4b6836583$export$f02972da195a43bb(marks, timingsConfig);
        (0, $a48Mt.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("bLOdU", function(module, exports) {
$parcel$export(module.exports, "getGlobalErrorCount", function () { return $891b0acb72298a37$export$d06c0426664e7c08; });

var $1nEzb = parcelRequire("1nEzb");

var $dH1HR = parcelRequire("dH1HR");
var $891b0acb72298a37$var$shouldInitilizeGlobalErrorHandler = true;
var $891b0acb72298a37$var$globalCount = 0;
var $891b0acb72298a37$var$errors = [];
var $891b0acb72298a37$var$push = function push(name, labelStack, errorType, errorMessage, errorStack) {
    $891b0acb72298a37$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
var $891b0acb72298a37$export$ebe081a8c9bf8176 = function sinkErrorHandler(sinkFunc) {
    $891b0acb72298a37$var$push = sinkFunc;
    $891b0acb72298a37$var$errors.forEach(function(e) {
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $891b0acb72298a37$var$errors.length = 0;
};
var $891b0acb72298a37$export$d06c0426664e7c08 = function getGlobalErrorCount() {
    return $891b0acb72298a37$var$globalCount;
};
var $891b0acb72298a37$var$handleError = function handleError(e) {
    var _e$error;
    $891b0acb72298a37$var$globalCount++;
    if (((_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.UFOhasCaught) === undefined) try {
        if (e.error instanceof Error) $891b0acb72298a37$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            var hint = JSON.stringify(e.error).slice(0, 50);
            $891b0acb72298a37$var$push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(hint), undefined);
        } else if (e.message !== undefined) {
            var _hint = e.message.slice(0, 50);
            $891b0acb72298a37$var$push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(_hint), undefined);
        }
        if (e.error && (0, $1nEzb.default)(e.error) === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var $891b0acb72298a37$var$handlePromiseRejection = function handlePromiseRejection(e) {
    $891b0acb72298a37$var$globalCount++;
    if (e.reason instanceof Error) $891b0acb72298a37$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        var hint = JSON.stringify(e.reason).slice(0, 50);
        $891b0acb72298a37$var$push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(hint), undefined);
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var $891b0acb72298a37$var$setupUFOGlobalErrorHandler = function setupUFOGlobalErrorHandler() {
    if ($891b0acb72298a37$var$shouldInitilizeGlobalErrorHandler) {
        (0, $dH1HR.bind)(window, {
            type: 'error',
            listener: function listener(e) {
                return $891b0acb72298a37$var$handleError(e);
            }
        });
        (0, $dH1HR.bind)(window, {
            type: 'unhandledrejection',
            listener: $891b0acb72298a37$var$handlePromiseRejection
        });
        $891b0acb72298a37$var$shouldInitilizeGlobalErrorHandler = false;
    }
};
var $891b0acb72298a37$export$2e2bcd8739ae039 = $891b0acb72298a37$var$setupUFOGlobalErrorHandler;

});

parcelRegister("8pUKJ", function(module, exports) {
$parcel$export(module.exports, "getTimings", function () { return $620cae715848f83f$export$6d488733a547304; });
var $620cae715848f83f$var$timings = [];
function $620cae715848f83f$export$758b9a33800fa436(name, startMark, stopMark) {
    var cleanStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var cleanStop = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    $620cae715848f83f$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $620cae715848f83f$export$6d488733a547304() {
    var reportedTimingsObj = {};
    $620cae715848f83f$var$timings.forEach(function(_ref) {
        var name = _ref.name, startMark = _ref.startMark, stopMark = _ref.stopMark, cleanStart = _ref.cleanStart, cleanStop = _ref.cleanStop;
        var startEntryList = performance.getEntriesByName(startMark);
        var stopEntryList = performance.getEntriesByName(stopMark);
        if ((startEntryList === null || startEntryList === void 0 ? void 0 : startEntryList.length) > 0 && (stopEntryList === null || stopEntryList === void 0 ? void 0 : stopEntryList.length) > 0) {
            var startEntry = startEntryList[startEntryList.length - 1];
            var stopEntry = stopEntryList[stopEntryList.length - 1];
            var startTime = startEntry.startTime;
            var duration = stopEntry.startTime - startTime;
            var timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});

parcelRegister("d39M6", function(module, exports) {
$parcel$export(module.exports, "getResourceTimings", function () { return $98032347c4da12f4$export$9eebb59359c2e9e5; });

var $gNkVH = parcelRequire("gNkVH");

var $03EZb = parcelRequire("03EZb");

var $87kDd = parcelRequire("87kDd");

var $gyWh8 = parcelRequire("gyWh8");

var $8Tf4I = parcelRequire("8Tf4I");
function $98032347c4da12f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98032347c4da12f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98032347c4da12f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98032347c4da12f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98032347c4da12f4$var$cacheableTypes = [
    'script',
    'link'
];
var $98032347c4da12f4$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var $98032347c4da12f4$var$CACHE_NETWORK = 'network';
var $98032347c4da12f4$var$CACHE_MEMORY = 'memory';
var $98032347c4da12f4$var$CACHE_DISK = 'disk';
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
var $98032347c4da12f4$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$98032347c4da12f4$var$cacheableTypes.includes(type)) return $98032347c4da12f4$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $98032347c4da12f4$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $98032347c4da12f4$var$CACHE_DISK;
    if (size === undefined) return null;
    return $98032347c4da12f4$var$CACHE_NETWORK;
};
var $98032347c4da12f4$var$getWindowObject = function getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
var $98032347c4da12f4$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$98032347c4da12f4$var$cacheableTypes.includes(type) || url.includes('localhost') || !!$98032347c4da12f4$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
var $98032347c4da12f4$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    var ufoConfig = (0, $03EZb.getConfig)();
    if (!(ufoConfig !== null && ufoConfig !== void 0 && ufoConfig.allowedResources)) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch'
        ];
    }
    return ufoConfig.allowedResources;
};
var $98032347c4da12f4$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(url, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
var $98032347c4da12f4$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $98032347c4da12f4$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $98032347c4da12f4$var$evaluateAccessToResourceTimings;
    var name = item.name, duration = item.duration, transferSize = item.transferSize, initiatorType = item.initiatorType, responseStart = item.responseStart, requestStart = item.requestStart, serverTime = item.serverTime, networkTime = item.networkTime, encodedSize = item.encodedSize, decodedSize = item.decodedSize;
    var ttfb = (0, $87kDd.roundEpsilon)(responseStart - eventStart);
    if (!$98032347c4da12f4$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($98032347c4da12f4$var$cacheableTypes.includes(initiatorType)) {
        var transferType = $98032347c4da12f4$var$calculateTransferType(initiatorType, duration, transferSize);
        return $98032347c4da12f4$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize
        }, $98032347c4da12f4$var$getSizeObject(transferSize));
    }
    return $98032347c4da12f4$var$_objectSpread({
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: requestStart
    }, $98032347c4da12f4$var$getSizeObject(transferSize));
};
var $98032347c4da12f4$export$9eebb59359c2e9e5 = function getResourceTimings(interactionStart, interactionEnd) {
    var resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    var resources = (0, $8Tf4I.filterResourceTimings)(interactionStart, interactionEnd);
    if (!(resources !== null && resources !== void 0 && resources.length)) return resourceTiming;
    var _getConfig = (0, $gyWh8.getConfig)(), xhrFilter = _getConfig.xhrFilter, sanitiseEndpoints = _getConfig.sanitiseEndpoints, mapResources = _getConfig.mapResources, hasTimingHeaders = _getConfig.hasTimingHeaders;
    var reportedInitiatorTypes = $98032347c4da12f4$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, initiatorType = item.initiatorType;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $98032347c4da12f4$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url) return;
        if (resourceTiming[url]) {
            resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
            return;
        }
        resourceTiming[url] = $98032347c4da12f4$var$_objectSpread({
            startTime: (0, $87kDd.roundEpsilon)(startTime - interactionStart),
            duration: (0, $87kDd.roundEpsilon)(duration),
            workerStart: Math.max((0, $87kDd.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, $87kDd.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType
        }, $98032347c4da12f4$var$getNetworkData(item, interactionStart, hasTimingHeaders));
    });
    return resourceTiming;
};

});
parcelRegister("8Tf4I", function(module, exports) {
$parcel$export(module.exports, "filterResourceTimings", function () { return $678f276668dbe34e$export$4138a729ef1db028; });

var $kOzMB = parcelRequire("kOzMB");

var $87kDd = parcelRequire("87kDd");
var $678f276668dbe34e$var$getPerformanceObject = function getPerformanceObject() {
    var _window;
    return ((_window = window) !== null && _window !== void 0 ? _window : {}).performance;
};
var $678f276668dbe34e$var$getPerformanceObserverObject = function getPerformanceObserverObject() {
    var _window2;
    return ((_window2 = window) !== null && _window2 !== void 0 ? _window2 : {}).PerformanceObserver;
};
var $678f276668dbe34e$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: function transformResource(entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        var duration = (0, $87kDd.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        var totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find(function(timing) {
            return timing.name === 'atl-edge';
        })) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        function(timing) {
            return timing.name === 'total' || timing.name === 'filter-request-papi';
        }));
        var serverTime = totalBackendTimeEntry ? (0, $87kDd.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        var networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $87kDd.roundEpsilon)(entry.startTime),
            duration: (0, $87kDd.roundEpsilon)(entry.duration),
            fetchStart: (0, $87kDd.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $87kDd.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $87kDd.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $87kDd.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $87kDd.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $87kDd.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start: function start() {
        var _performance$getEntri;
        var performance = $678f276668dbe34e$var$getPerformanceObject();
        var PerformanceObserver = $678f276668dbe34e$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($678f276668dbe34e$export$bea963256235a63e.observer) return;
        var resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $678f276668dbe34e$export$bea963256235a63e.timings = resources.map(function(resource) {
            return $678f276668dbe34e$export$bea963256235a63e.transformResource(resource);
        });
        $678f276668dbe34e$export$bea963256235a63e.observer = new PerformanceObserver($678f276668dbe34e$export$bea963256235a63e.addTimings);
        $678f276668dbe34e$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: function stop() {
        if ($678f276668dbe34e$export$bea963256235a63e.observer) {
            $678f276668dbe34e$export$bea963256235a63e.observer.disconnect();
            $678f276668dbe34e$export$bea963256235a63e.observer = null;
        }
        $678f276668dbe34e$export$bea963256235a63e.timings = [];
    },
    addTimings: function addTimings(list) {
        var _resourceTimingBuffer;
        var entries = list.getEntries().map(function(entry) {
            return $678f276668dbe34e$export$bea963256235a63e.transformResource(entry);
        });
        var overflow = $678f276668dbe34e$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $678f276668dbe34e$export$bea963256235a63e.maxSize) {
            var fieldsToRemove = overflow - $678f276668dbe34e$export$bea963256235a63e.maxSize;
            $678f276668dbe34e$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        (_resourceTimingBuffer = $678f276668dbe34e$export$bea963256235a63e.timings).push.apply(_resourceTimingBuffer, (0, $kOzMB.default)(entries));
    }
};
var $678f276668dbe34e$var$isValidTiming = function isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
};
var $678f276668dbe34e$export$4138a729ef1db028 = function filterResourceTimings(startTime, endTime) {
    var performance = $678f276668dbe34e$var$getPerformanceObject();
    var PerformanceObserver = $678f276668dbe34e$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$678f276668dbe34e$export$bea963256235a63e.observer) {
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter(function(timing) {
            return $678f276668dbe34e$var$isValidTiming(timing, startTime, endTime);
        });
        return null;
    }
    return $678f276668dbe34e$export$bea963256235a63e.timings.filter(function(timing) {
        return $678f276668dbe34e$var$isValidTiming(timing, startTime, endTime);
    });
};

});


parcelRegister("hij2V", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", function () { return $c972e443a79fb0fe$export$e08487ea3ae92adb; });
$parcel$export(module.exports, "isSegmentLabel", function () { return $c972e443a79fb0fe$export$1adbaf5c2363e4ae; });
$parcel$export(module.exports, "buildSegmentTree", function () { return $c972e443a79fb0fe$export$1569bc0edeecbcd8; });
$parcel$export(module.exports, "stringifyLabelStackFully", function () { return $c972e443a79fb0fe$export$caeee352b541de1f; });
$parcel$export(module.exports, "labelStackStartWith", function () { return $c972e443a79fb0fe$export$1787b1cd413c7e2; });
$parcel$export(module.exports, "optimizeLabelStack", function () { return $c972e443a79fb0fe$export$a0cd72da07c76b4c; });

var $gNkVH = parcelRequire("gNkVH");

var $geLu7 = parcelRequire("geLu7");
function $c972e443a79fb0fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c972e443a79fb0fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c972e443a79fb0fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $gNkVH.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c972e443a79fb0fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c972e443a79fb0fe$export$e08487ea3ae92adb = function sanitizeUfoName(name) {
    return name.replace(/_/g, '-');
};
function $c972e443a79fb0fe$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $c972e443a79fb0fe$export$1569bc0edeecbcd8(labelStacks) {
    var r = {
        n: 'segment-tree-root',
        c: {}
    };
    labelStacks.forEach(function(labelStack) {
        var currentNode = r;
        labelStack.forEach(function(label) {
            var name = label.name;
            var id = $c972e443a79fb0fe$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            var key = id !== undefined ? id : name;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $c972e443a79fb0fe$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        if ($c972e443a79fb0fe$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join('/');
}
function $c972e443a79fb0fe$var$getLabelStackReference(labelStack) {
    return labelStack.map(function(l) {
        return $c972e443a79fb0fe$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name;
    }).join('/');
}
function $c972e443a79fb0fe$export$1787b1cd413c7e2(labelStack, startWith) {
    return $c972e443a79fb0fe$export$caeee352b541de1f(labelStack).startsWith($c972e443a79fb0fe$export$caeee352b541de1f(startWith));
}
function $c972e443a79fb0fe$export$a0cd72da07c76b4c(labelStack) {
    return (0, $geLu7.REACT_UFO_VERSION) === '2.0.0' ? $c972e443a79fb0fe$var$getLabelStackReference(labelStack) : labelStack.map(function(ls) {
        return $c972e443a79fb0fe$var$_objectSpread({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {});
    });
}

});



//# sourceMappingURL=create-payload.2ee1bd4d.js.map
